<template> 
  <div class='container' style="max-height:99vh">

          <Load :isLoading='Loading'/>
  <header>
            <Header
        :HideCart='false'
        Title='Cadastro novo cliente' 
        />
  </header>

    <section v-show='cadastrado'>

        <CenteredFigure
      class='centerImage'
      :Img='emailSend'
      />

      <div class='card-body'>
        <h4 class='card-title princing-card-title text-center'>Enviamos o acesso no seu E-MAIL.</h4>
        <ul class="list-unstyled  text-center">
              <li>Acesse seu e-mail e clique no botão de acesso</li>
            </ul>
      </div>

    <FooterContainer>




        

    </FooterContainer>

  </section>

  <section v-show='!cadastrado'>

   <form class='register' >


      
      <div class='card-body'>
        <h4 class='card-title princing-card-title text-center'>Ainda não tem uma conta? </h4>
        <ul class="list-unstyled  text-center">
              <li>Cadastre-se agora mesmo.</li>
            </ul>
      </div>


      <InputRedLight
          class="inputName" 
          autoComplete="off"
          placeholder='Nome e sobrenome'
          id="nome"
          type="text"
          minLength=6
          maxLength=50
          title="Digite seu nome" 
          v-model.trim="$v.nome.$model"

       />

      <InputRedLight
          required
          autoComplete="off"
          placeholder='Seu melhor e-mail'
          id="email"
          type="email"
          minLength=6
          maxLength=50
          title="Digite seu email"
          v-model="$v.email.$model"
          

       />

      <div class="error" v-if="!$v.email.email">Insira um e-mail válido</div>


        <the-mask 
        :mask="['(##) ####-####', '(##) #####-####']"            
        required
        placeholder='Seu número de celular'
        v-model="$v.whatsapp.$model"
 
        />
      
      <InputRedLight
            class='form-group'
            :class="{ 'form-group--error': $v.password.$error }"
            autoComplete="off"
            placeholder='Senha'
            id="password"
            type="password"
            minLength=6
            maxLength=20
            title="digite sua senha"
            v-model="$v.password.$model"

        />
        <div class="error" v-if="!$v.password.required">A senha é obrigatória.</div>
        <div class="error" v-if="!$v.password.minLength">A senha deve ter pelo menos {{ $v.password.$params.minLength.min }} letras ou números.</div>
      <InputRedLight
            v-show='password'
            :class="{ 'form-group--error': $v.confirmPassword.$error }"
            autoComplete="off"
            placeholder='Confirmação da senha'
            id="password"
            type="password"
            minLength=6
            maxLength=20
            title="digite sua senha"
            v-model="$v.confirmPassword.$model"

        />
        <div class="error" v-if="!$v.confirmPassword.sameAsPassword">As senhas precisam ser idênticas.</div>

        <Button
        v-show='this.nome.length > 3 && this.whatsapp.length > 10 && this.email.length > 4 && this.confirmPassword.length > 4'
        id='next_button'
        Type='submit'
        Text='CADASTRAR'
        :ButtonFunction='goRegister'
        @submit.prevent="handleSubmit"
        />

    </form>

  </section>
  </div> 
</template>

<script>
import emailSend from '../../assets/img/emailSend.svg'
import CenteredFigure from '../../components/ImageStyle/CenteredFigure'
import { required, sameAs, email, minLength } from 'vuelidate/lib/validators'
import InputRedLight from '../../components/Input/InputRedLight'
import Header from '../../components/Header/Header'
import Logo from '../../assets/img/appName.svg'
import Button from '../../components/Button/ButtonCallToAction'
import FooterContainer from '../../components/Container/FooterContainer'
import Load from '../../components/Load/LoadOverlay'
import {checkNewUser} from '../../tools/checkNewUser'
import {mapActions} from 'vuex'

export default {

  components: {
    InputRedLight,
    Header,
    Button,
    CenteredFigure,
    FooterContainer,
    Load
  },
  validations: {
    nome:{
      required,
      minLength: minLength(6)
    },
    email:{
      required,email
    },
    whatsapp:{
      required,
      minLength: minLength(9)
    },
    password: {
      required,
      minLength: minLength(6)
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  },
  data() {
    return {
      submitted: false,
      Loading:false,
      Logo: Logo,

        nome: '',
        email:  '',
        whatsapp: '',
        password:'',
        confirmPassword:'',
        cadastrado:false,
        emailSend:emailSend

    }
  },
  methods: {
      ...mapActions('register',['ActionNewClient']),
     getAcess (){
        this.$router.push('https://api.whatsapp.com/send?phone=5531984404639&text=Ol%C3%A1%20fiz%20o%20cadastro%20e%20gostaria%20de%20receber%20meu%20acesso.'); 
     },
     async goRegister() {
      this.Loading = !this.Loading
      const check = checkNewUser(this.nome,this.whatsapp,this.email,this.password)
      console.log(check)
      
      if (check === false ){
           
          this.nome = '',
          this.email = '',
          this.whatsapp = '',
          this.password = '',
          this.confirmPassword =''
          this.Loading = !this.Loading
          alert('Impossivel cadastrar com esses dados.')
      }

      else {
                   

      const newClient = {
        'name':this.nome,
        'email':this.email,
        'whatsapp':this.whatsapp,
        'password':this.confirmPassword
      }

      const registro = await this.ActionNewClient(newClient)

      if (registro == 201){
                

        this.cadastrado = !this.cadastrado
        this.Loading = !this.Loading
      }

      if (registro == 400){
  

        this.nome = '',
        this.email = '',
        this.whatsapp = '',
        this.password = '',
        this.confirmPassword =''
        this.Loading = !this.Loading
        
      }

      }
      },

       
  },
  
}
</script>

<style scoped lang="css">

a {
  background-color: #128C7E;
  color: white;
  padding: 1em 1em;
  text-decoration: none;
  text-transform: uppercase;
  
}


.centerImage{
  margin-top: 50%;
}
.centerLink{
  margin-left: .5rem;
  margin-right: .9rem;
}

input {
        background-color: var(--main-red-light);
        background: var(--main-red-light);
        border: 2px solid transparent;
        border-radius: 0.5rem;
        font-weight: 500;
        padding: 0.5rem;
        width: 100%;
        margin-bottom:.6rem;
    };
        :focus {
            outline: none;
        }
        ::placeholder {
            color: var(--main-black);
        }

.titleh1{
  display: flex;
align-items: center;
text-align: center;
}

.inputName{
  margin-top:.25rem;
}

#next_button{
  margin-top:1.5rem;
}
  .register{
    display:block;
    width:90%;    
    margin-left:auto;
    margin-right:auto;  
    margin-top:4.25rem;  
}

  @media (min-width: 1000px) and (max-width: 2600px) {
  .register{
    display:block;
    width:40%;    
    margin-left:auto;
    margin-right:auto;  
}
  }

  
</style>
